const CommentPolicy = () => {
  return (
    <div className="w-full h-full">
      <div className="text-center pt-36 bg-white h-screen	">
        <h1 className="text-4xl mb-10" style={{ fontFamily: 'lato-black' }}>
          Pravila komentarisanja:
        </h1>
        <div className="mb-8">
          <p className="text-l mb-8" style={{ fontFamily: 'lato-black' }}>
            Redakcija zadržava pravo izbora komentara koji će biti objavljeni.
          </p>
          <p className="text-l mb-4">
            -Komentari koji sadrže psovke, uvrede, prijetnje i govor mržnje na
            nacionalnoj, vjerskoj, rasnoj osnovi, kao i netoleranciju svake
            vrste neće biti objavljeni..
          </p>
          <p className="text-l mb-4">
            -Prilikom pisanja komentara vodite računa o pravopisnim i
            gramatičkim pravilima.
          </p>
          <p className="text-l mb-4">
            -Nije dozvoljeno pisanje komentara isključivo velikim slovima niti
            promovisanje drugih sajtova putem linkova.
          </p>
          <p className="text-l mb-4">
            -Komentari u kojima nam skrećete pažnju na slovne, tehničke i druge
            propuste u tekstovima neće biti objavljeni, ali ih možete uputiti
            redakciji na kontakt stranici portala.
          </p>
          <p className="text-l mb-4">
            -Komentare i sugestije u vezi sa uređivačkom politikom ne
            objavljujemo, kao ni komentare koji sadrže optužbe protiv drugih
            osoba.
          </p>
          <p className="text-l mb-4">
            -Objavljeni komentari predstavljaju privatno mišljenje autora
            komentara, i nijesu stavovi redakcije portala.
          </p>
        </div>
      </div>
    </div>
  )
}

export default CommentPolicy
